/* esm.sh - preact-feather@4.2.1 */
export * from "/preact-feather@4.2.1/X-ZXByZWFjdA/denonext/preact-feather.mjs";
